<div class="flex flex-column h-full overflow-hidden" [ngClass]="isPanel ? 'px-2' : 'px-3'">

    <!-- Colonne de lecture : responsive sur la page (déclarée une seule fois pour tout l'écran), pleine largeur dans le panneau -->
    <div class="flex flex-column h-full overflow-hidden p-0"
        [ngClass]="isPanel ? 'w-full' : 'col-12 xl:col-10 xl:col-offset-1 dxl:col-8 dxl:col-offset-2'">

        <!-- Barre d'outils : titre et fermeture du panneau, passage d'un mode à l'autre -->
        <div class="flex align-items-center flex-shrink-0 gap-2"
            [ngClass]="isPanel ? 'justify-content-between py-2' : 'justify-content-end pb-2'">
            @if (isPanel) {
            <div class="flex align-items-center gap-2 pl-1">
                <i class="bi bi-ai-sparkles-solo text-purple-400"></i>
                <span class="font-semibold text-color">Assistant IA</span>
            </div>
            }
            <div class="flex align-items-center">
                @if (inConversation) {
                <p-button icon="pi pi-plus" [text]="true" [rounded]="true" severity="secondary"
                    pTooltip="Nouvelle conversation" tooltipPosition="bottom"
                    (onClick)="onClickNewConversation()"></p-button>
                }
                @if (isPanel) {
                <p-button icon="pi pi-window-maximize" [text]="true" [rounded]="true" severity="secondary"
                    pTooltip="Ouvrir en pleine page" tooltipPosition="bottom" (onClick)="onClickExpand()"></p-button>
                <p-button icon="pi pi-times" [text]="true" [rounded]="true" severity="secondary"
                    pTooltip="Fermer le panneau" tooltipPosition="bottom" (onClick)="onClickClose()"></p-button>
                } @else {
                <p-button icon="pi pi-window-minimize" [text]="true" [rounded]="true" severity="secondary"
                    pTooltip="Réduire en panneau" tooltipPosition="bottom" (onClick)="onClickReduce()"></p-button>
                }
            </div>
        </div>

        @if (loadingSession) {
        <!-- Chargement d'une conversation existante -->
        <div class="flex-1 flex align-items-center justify-content-center">
            <p-progress-spinner strokeWidth="4" class="w-4rem h-4rem"></p-progress-spinner>
        </div>
        } @else if (!inConversation) {
        <!-- Accueil. Page : champ centré + dernières conversations. Panneau : le titre au centre,
             le champ en bas comme dans une conversation, et pas d'historique -->
        <div class="flex-1 overflow-y-auto overflow-x-hidden flex flex-column justify-content-center"
            [ngClass]="isPanel ? 'gap-4 py-3' : 'gap-5 py-5'">
            <div class="flex flex-column align-items-center gap-3 text-center">
                <i class="bi bi-ai-sparkles text-purple-400" [ngClass]="isPanel ? 'text-5xl' : 'text-7xl'"></i>
                <h1 class="font-semibold text-color m-0" [ngClass]="isPanel ? 'text-xl' : 'text-3xl'">Comment puis-je vous aider ?</h1>
            </div>

            @if (!isPanel) {
            <app-assistant-composer [disabled]="streaming" (send)="onSendText($event)"></app-assistant-composer>
            }

            <!-- Propositions de l'agent en attente : les miennes, et celles que je peux appliquer -->
            @if (pendingActions.length) {
            <div class="flex flex-column gap-2 px-1">
                <span class="text-sm text-color-secondary">En attente d'une décision</span>
                @for (action of pendingActions; track action.id) {
                <app-assistant-action-card [action]="action" (changed)="onChangeAction()"></app-assistant-action-card>
                }
            </div>
            }

            @if (!isPanel && (loadingRecent || recentSessions.length)) {
            <div class="flex flex-column gap-2 px-1">
                <span class="text-sm text-color-secondary">Conversations récentes</span>
                <app-assistant-recent [sessions]="recentSessions" [loading]="loadingRecent"
                    (openSession)="onOpenSession($event)" (renameSession)="onRenameSession($event)"
                    (deleteSession)="onDeleteSession($event)"></app-assistant-recent>
            </div>
            }
        </div>
        @if (isPanel) {
        <div class="flex-shrink-0 pb-3">
            <app-assistant-composer [disabled]="streaming" borderClass="border-300"
                (send)="onSendText($event)"></app-assistant-composer>
        </div>
        }
        } @else {
        <!-- Conversation : fil + champ en bas -->
        <div #thread class="flex-1 overflow-y-auto overflow-x-hidden" [ngClass]="isPanel ? 'py-2' : 'p-4 pl-0'">
            <app-assistant-conversation [messages]="messages" [statusText]="statusText"
                [pendingTurnIndex]="undoingTurnIndex" [turnUndoReport]="turnUndoReport"
                [sessionId]="activeSessionId" [feedbackReadonly]="feedbackReadonly"
                (openDoc)="onOpenDoc($event)" (undoTurn)="onUndoTurn($event)"
                (feedbackChange)="onChangeFeedback($event)"></app-assistant-conversation>
        </div>
        <div class="flex-shrink-0 pb-3">
            <!-- Total de la conversation : tokens cumulés + coût estimatif, ventilés -->
            @if (sessionUsage) {
            <div class="text-right mb-1 px-1">
                <app-assistant-usage [usage]="sessionUsage" label="Total conversation"></app-assistant-usage>
            </div>
            }
            <app-assistant-composer [disabled]="streaming" [borderClass]="isPanel ? 'border-300' : 'border-500'"
                (send)="onSendText($event)"></app-assistant-composer>
        </div>
        }

    </div>
</div>

<!-- Renommage -->
<p-dialog [(visible)]="renameDialogVisible" [modal]="true" [draggable]="false" [resizable]="false"
    header="Renommer la conversation" [style]="{ width: '28rem' }">
    <input pInputText class="w-full" [(ngModel)]="renameTitle" (keydown.enter)="onConfirmRename()" />
    <div class="flex justify-content-end gap-2 mt-3">
        <p-button label="Annuler" [text]="true" severity="secondary" [rounded]="true" (onClick)="renameDialogVisible = false"></p-button>
        <p-button label="Renommer" [disabled]="!renameTitle.trim()" [rounded]="true" (onClick)="onConfirmRename()"></p-button>
    </div>
</p-dialog>
